import React, { useState, useEffect } from 'react';

const SOURCES = {
  ops: [
    { name: 'Portainer', url: 'https://portainer.devboxnsa.org', desc: 'Container-Management', type: 'Tool' },
    { name: 'Netdata', url: 'https://100.64.0.1:19999', desc: 'Server-Monitoring', type: 'Tool' },
    { name: 'Uptime Kuma', url: 'https://uptime.devboxnsa.org', desc: '25 Service-Monitore', type: 'Tool' },
    { name: 'GoAccess', url: 'https://logs.devboxnsa.org', desc: 'Nginx Log Analyzer', type: 'Tool' },
    { name: 'Dockge', url: 'https://dockge.devboxnsa.org', desc: 'Stack Management', type: 'Tool' },
    { name: 'Docker API', desc: 'Container Status via SSH', type: 'API' },
  ],
  sec: [
    { name: 'Authentik', url: 'https://auth.devboxnsa.org', desc: 'SSO & Identity Provider', type: 'Service' },
    { name: 'Vaultwarden', url: 'https://vault.devboxnsa.org', desc: 'Passwort-Manager', type: 'Service' },
    { name: 'Headplane', url: 'https://headplane.devboxnsa.org', desc: 'VPN Dashboard', type: 'Tool' },
    { name: 'CrowdSec', desc: 'Threat Detection Engine', type: 'Service' },
    { name: 'Fail2ban', desc: 'Brute-Force Schutz', type: 'Service' },
    { name: 'Certbot', desc: 'SSL Zertifikate (Lets Encrypt)', type: 'Tool' },
  ],
  crm: [
    { name: 'Invoice Ninja', url: 'https://invoice.devboxnsa.org', desc: 'Rechnungen & Angebote', type: 'Service' },
    { name: 'Forgejo Clients', url: 'https://git.devboxnsa.org/devbox-clients', desc: 'Kunden-Repos', type: 'Service' },
    { name: 'Nextcloud', url: 'https://cloud.devboxnsa.org', desc: 'Kundendokumente', type: 'Service' },
    { name: 'Time Tracker', desc: 'Browser-basiert (localStorage)', type: 'Intern' },
  ],
  comm: [
    { name: 'Element Web', url: 'https://element.devboxnsa.org', desc: 'Matrix Chat Client', type: 'Service' },
    { name: 'Conduit', url: 'https://matrix.devboxnsa.org', desc: 'Matrix Server', type: 'Service' },
    { name: 'Ntfy', url: 'https://ntfy.devboxnsa.org', desc: 'Push-Notifications', type: 'Service' },
    { name: 'Miniflux', url: 'https://feeds.devboxnsa.org', desc: 'RSS Reader', type: 'Service' },
    { name: 'Proton Mail', url: 'https://mail.proton.me', desc: 'E-Mail', type: 'Extern' },
  ],
  dev: [
    { name: 'Forgejo', url: 'https://git.devboxnsa.org', desc: 'Git Server (6 Repos)', type: 'Service' },
    { name: 'Ollama', desc: 'Lokale LLMs (4 Modelle)', type: 'Service' },
    { name: 'Portainer', url: 'https://portainer.devboxnsa.org', desc: 'Docker UI', type: 'Tool' },
    { name: 'Dockge', url: 'https://dockge.devboxnsa.org', desc: 'Stack Management', type: 'Tool' },
  ],
  projects: [
    { name: 'Forgejo', url: 'https://git.devboxnsa.org', desc: 'Alle Projekt-Repos', type: 'Service' },
    { name: 'Nextcloud', url: 'https://cloud.devboxnsa.org', desc: 'Dateien & Kalender', type: 'Service' },
  ],
  wiki: [
    { name: 'BookStack', url: 'https://docs.devboxnsa.org', desc: 'Technische Docs', type: 'Service' },
    { name: 'Outline', url: 'https://wiki.devboxnsa.org', desc: 'Team-Wiki', type: 'Service' },
    { name: 'SilverBullet', url: 'https://notes.devboxnsa.org', desc: 'Markdown-Notizen', type: 'Tool' },
    { name: 'DocBrain', url: 'https://brain.devboxnsa.org', desc: 'RAG-Dokumentensuche', type: 'Service' },
  ],
  media: [
    { name: 'Nextcloud', url: 'https://cloud.devboxnsa.org', desc: 'Medien-Ablage', type: 'Service' },
    { name: 'Jellyfin', desc: 'Media Server (geplant)', type: 'Geplant' },
  ],
  private: [
    { name: 'Intel Platform', url: 'https://intel.devboxnsa.org', desc: '152k Artikel', type: 'Projekt' },
    { name: 'Job Tracker', url: 'https://jobs.devboxnsa.org', desc: '366 Jobs', type: 'Projekt' },
    { name: 'Nextcloud', url: 'https://cloud.devboxnsa.org', desc: 'Persoenliche Dateien', type: 'Service' },
    { name: 'Vaultwarden', url: 'https://vault.devboxnsa.org', desc: 'Passwoerter', type: 'Service' },
  ],
  home: [
    { name: 'Netdata', url: 'https://100.64.0.1:19999', desc: 'System-Monitoring', type: 'Tool' },
    { name: 'Speedtest', url: 'https://speed.devboxnsa.org', desc: 'Bandbreite (6h)', type: 'Tool' },
    { name: 'Headscale', url: 'https://headplane.devboxnsa.org', desc: 'VPN (3 Nodes)', type: 'Service' },
  ],
  creative: [
    { name: 'Canva', url: 'https://canva.com', desc: 'Design-Tool', type: 'Extern' },
    { name: 'Gamma', url: 'https://gamma.app', desc: 'KI-Praesentationen', type: 'Extern' },
    { name: 'Nextcloud', url: 'https://cloud.devboxnsa.org', desc: 'Assets & Medien', type: 'Service' },
    { name: 'Ollama', desc: 'KI Content-Generierung', type: 'Service' },
  ],
  master: [
    { name: 'Uptime Kuma', url: 'https://uptime.devboxnsa.org', desc: 'Alle Monitore', type: 'Tool' },
    { name: 'Agent Dashboard', url: 'https://agent.devboxnsa.org', desc: 'Cron & Scripts', type: 'Tool' },
    { name: 'Orchestrator', url: 'https://orchestrator.devboxnsa.org', desc: 'Service-Graph', type: 'Tool' },
  ],
  data: [
    { name: 'PostgreSQL', desc: '8 Instanzen', type: 'Service' },
    { name: 'Redis', desc: '6 Instanzen', type: 'Service' },
    { name: 'Ollama', desc: '4 LLM Modelle', type: 'Service' },
    { name: 'n8n', url: 'https://n8n.devboxnsa.org', desc: 'Workflow-Engine', type: 'Tool' },
  ],
  admin: [
    { name: 'data-backend', desc: 'FastAPI, 127 Endpoints, 17 Router', type: 'API' },
    { name: 'SQLite', desc: 'Users, Tokens, Memory', type: 'DB' },
    { name: 'Nginx', desc: '53 Sites konfiguriert', type: 'Service' },
  ],
  ai: [
    { name: 'Claude API', desc: 'Haiku 4.5 + Sonnet 4.5', type: 'Extern' },
    { name: 'Ollama', desc: 'llama3.2, llama3.1, qwen2.5, nomic-embed', type: 'Service' },
    { name: 'n8n', url: 'https://n8n.devboxnsa.org', desc: 'Workflow-Automatisierung', type: 'Tool' },
    { name: 'DocBrain', url: 'https://brain.devboxnsa.org', desc: 'RAG Embeddings', type: 'Service' },
  ],
  docbrain: [
    { name: 'Claude API', desc: 'Sonnet fuer Analyse, Haiku fuer Agent', type: 'Extern' },
    { name: 'Ollama', desc: 'nomic-embed-text (RAG Embeddings)', type: 'Service' },
    { name: 'PostgreSQL', desc: 'pgvector, Dokumente + Chunks', type: 'DB' },
    { name: 'Redis', desc: 'Celery Task Queue', type: 'Service' },
  ],
};

const FACTS = {
  ops: [
    { key: 'Server', value: 'Contabo VPS, Ubuntu 24.04, 6C, 12 GB RAM' },
    { key: 'Container', value: '71 laufend, 91 total' },
    { key: 'Port', value: '8030 (Frontend), 8024 (Backend)' },
    { key: 'Backup', value: '6 Cron-Jobs, taeglich 03:00-04:15' },
    { key: 'Monitoring', value: '25 Uptime Kuma Monitore' },
  ],
  sec: [
    { key: 'VPN', value: 'Headscale 3 Nodes + NetBird 4 Peers' },
    { key: 'SSL', value: '40+ Certbot Zertifikate' },
    { key: 'Auth', value: 'Basic Auth (htpasswd) + Authentik SSO' },
    { key: 'Firewall', value: 'UFW + Fail2ban + CrowdSec' },
  ],
  crm: [
    { key: 'Kunden', value: 'Slooth (aktiv, 120 EUR/h), Werner/WVS (Proposal)' },
    { key: 'Steuern', value: 'Kleinunternehmerregelung §19 UStG' },
    { key: 'Rechnungen', value: 'Invoice Ninja (PDF-Erstellung)' },
    { key: 'Zeit', value: 'Browser-basiert, localStorage' },
  ],
  comm: [
    { key: 'Matrix', value: '5 Channels: #general, #intel, #system, #business, #home' },
    { key: 'Ntfy', value: 'devbox-briefing (17:00), devbox-alerts (sofort)' },
    { key: 'RSS', value: 'Miniflux, 152k Artikel, 1.1 GB' },
    { key: 'Bot', value: 'devbox-bot in allen Matrix Channels' },
  ],
  dev: [
    { key: 'Git', value: 'Forgejo, 6 aktive Repos, SSH Port 2222' },
    { key: 'Ollama', value: '4 Modelle: llama3.2, llama3.1, qwen2.5, nomic-embed' },
    { key: 'Stack', value: 'React 18, Vite 5, FastAPI, Docker' },
  ],
  projects: [
    { key: 'Intel Platform', value: '80% fertig, 152k Artikel, PostGIS' },
    { key: 'Job Tracker', value: '70% fertig, 366 Jobs, CV Builder' },
    { key: 'DocBrain', value: '75% fertig, 8 Dokumente, RAG' },
    { key: 'Slooth', value: '85% fertig, Kundenprojekt' },
  ],
  wiki: [
    { key: 'BookStack', value: 'Technische Dokumentation, MariaDB' },
    { key: 'Outline', value: 'Team-Wiki, PostgreSQL + Authentik' },
    { key: 'DocBrain', value: 'RAG-basiert, 8 Docs, 20 Chunks' },
  ],
  media: [
    { key: 'Nextcloud', value: '23.8 GB / 56.9 GB belegt' },
    { key: 'Jellyfin', value: 'Geplant fuer Home Server' },
  ],
  private: [
    { key: 'Intel', value: '152k Artikel, JWT deaktiviert, VPN-only' },
    { key: 'Jobs', value: '366 Jobs, Match Score, Pipeline' },
    { key: 'Finance', value: 'Pausiert, 4 Indizes (Mock)' },
  ],
  home: [
    { key: 'Home Server', value: 'Pop!_OS 22.04, GTX 1050 Ti, 916 GB HDD' },
    { key: 'Backup', value: 'rsync DevBox → Home Server taeglich 04:15' },
    { key: 'VPN', value: 'Headscale + NetBird' },
  ],
  creative: [
    { key: 'Design', value: 'Canva + Gamma fuer Praesentationen' },
    { key: 'KI', value: 'Ollama fuer Content-Generierung' },
  ],
  master: [
    { key: 'Domains', value: '16 Sub-Apps im Ecosystem' },
    { key: 'Backend', value: '127 Endpoints, 17 Router-Module' },
    { key: 'SQLite', value: 'Users, Tokens, Memory, Agents, Files' },
  ],
  data: [
    { key: 'PostgreSQL', value: '8 Instanzen, groesste: Miniflux 1.1 GB' },
    { key: 'Redis', value: '6 Instanzen, 1-2.4 MB je' },
    { key: 'Storage', value: '136 GB / 193 GB (71%)' },
  ],
  admin: [
    { key: 'Users', value: '1 (nsa, Admin, unlimited Tokens)' },
    { key: 'Multi-Tenancy', value: 'SQLite, X-User-ID Header' },
    { key: 'Nginx', value: '53 Sites, Basic Auth + SSL' },
  ],
  ai: [
    { key: 'Claude API', value: 'Haiku fuer Chat, Sonnet fuer Analyse' },
    { key: 'Token-System', value: 'ai.chat=1, ai.report=5, ai.agent=10' },
    { key: 'Agenten', value: '16 Domain-Agents + 1 Global Agent' },
    { key: 'Memory', value: 'SQLite ai_memory, pro User + Domain' },
  ],
  docbrain: [
    { key: 'Dokumente', value: '12 Dateien, 20 Chunks (RAG)' },
    { key: 'Analyse', value: 'Claude Sonnet SSE Streaming' },
    { key: 'Embeddings', value: 'Ollama nomic-embed-text' },
    { key: 'Port', value: '8005 (Backend), 8048 (Frontend)' },
  ],
};

const DEPS = {
  ops: [
    { service: 'Nginx', depends: ['Docker', 'Certbot'], status: 'ok' },
    { service: 'Docker', depends: ['DevBox Host'], status: 'ok' },
    { service: 'Headscale', depends: ['Docker', 'Nginx'], status: 'ok' },
    { service: 'Backup', depends: ['Cron', 'Home Server', 'Ntfy'], status: 'ok' },
    { service: 'data-backend', depends: ['Docker', 'SSH', 'SQLite'], status: 'ok' },
  ],
  sec: [
    { service: 'Authentik', depends: ['PostgreSQL', 'Nginx', 'Docker'], status: 'ok' },
    { service: 'Vaultwarden', depends: ['Docker', 'Nginx'], status: 'ok' },
    { service: 'Headscale', depends: ['Docker', 'Nginx', 'SQLite'], status: 'ok' },
    { service: 'CrowdSec', depends: ['Docker', 'Nginx Logs'], status: 'warn' },
  ],
  crm: [
    { service: 'Invoice Ninja', depends: ['Docker', 'MySQL', 'Nginx'], status: 'ok' },
    { service: 'Forgejo', depends: ['Docker', 'PostgreSQL', 'Nginx'], status: 'ok' },
  ],
  comm: [
    { service: 'Conduit', depends: ['Docker', 'Nginx'], status: 'ok' },
    { service: 'Ntfy', depends: ['Docker', 'Nginx'], status: 'ok' },
    { service: 'Miniflux', depends: ['Docker', 'PostgreSQL', 'Nginx'], status: 'ok' },
  ],
  dev: [
    { service: 'Forgejo', depends: ['Docker', 'PostgreSQL', 'SSH'], status: 'ok' },
    { service: 'Ollama', depends: ['Host GPU/CPU'], status: 'ok' },
  ],
  projects: [
    { service: 'Forgejo', depends: ['Docker', 'PostgreSQL'], status: 'ok' },
    { service: 'Nextcloud', depends: ['Docker', 'PostgreSQL', 'Redis'], status: 'ok' },
  ],
  wiki: [
    { service: 'BookStack', depends: ['Docker', 'MariaDB'], status: 'ok' },
    { service: 'Outline', depends: ['Docker', 'PostgreSQL', 'MinIO', 'Authentik'], status: 'ok' },
    { service: 'DocBrain', depends: ['Docker', 'pgvector', 'Ollama'], status: 'ok' },
  ],
  media: [
    { service: 'Nextcloud', depends: ['Docker', 'PostgreSQL', 'Redis'], status: 'ok' },
  ],
  private: [
    { service: 'Intel API', depends: ['Docker', 'PostGIS', 'Miniflux'], status: 'ok' },
    { service: 'Jobs API', depends: ['Docker', 'PostgreSQL', 'n8n'], status: 'ok' },
  ],
  home: [
    { service: 'Home Server', depends: ['VPN (Headscale)', 'SSH'], status: 'ok' },
    { service: 'Backup rsync', depends: ['Cron', 'SSH', 'Home Server HDD'], status: 'ok' },
  ],
  creative: [
    { service: 'Nextcloud', depends: ['Docker', 'PostgreSQL'], status: 'ok' },
    { service: 'Ollama', depends: ['Host'], status: 'ok' },
  ],
  master: [
    { service: 'data-backend', depends: ['Docker', 'SSH', 'SQLite', 'Ollama'], status: 'ok' },
    { service: 'Uptime Kuma', depends: ['Docker'], status: 'ok' },
  ],
  data: [
    { service: 'PostgreSQL (8x)', depends: ['Docker'], status: 'ok' },
    { service: 'Redis (6x)', depends: ['Docker'], status: 'ok' },
    { service: 'Ollama', depends: ['Host'], status: 'ok' },
    { service: 'n8n', depends: ['Docker'], status: 'ok' },
  ],
  admin: [
    { service: 'data-backend', depends: ['Docker', 'SSH', 'SQLite'], status: 'ok' },
    { service: 'Nginx', depends: ['Certbot', 'htpasswd'], status: 'ok' },
  ],
  ai: [
    { service: 'Claude API', depends: ['ANTHROPIC_API_KEY', 'Internet'], status: 'ok' },
    { service: 'Ollama', depends: ['Host', '11434'], status: 'ok' },
    { service: 'data-backend', depends: ['Docker', 'SQLite'], status: 'ok' },
  ],
  docbrain: [
    { service: 'docbrain-backend', depends: ['Docker', 'pgvector', 'Redis', 'Ollama'], status: 'ok' },
    { service: 'Claude API', depends: ['ANTHROPIC_API_KEY', 'Internet'], status: 'ok' },
    { service: 'Celery Worker', depends: ['Docker', 'Redis', 'pgvector'], status: 'ok' },
    { service: 'docbrain-frontend', depends: ['Docker', 'Nginx'], status: 'ok' },
  ],
};

const TABS = [
  { key: 'sources', label: 'Sources' },
  { key: 'facts', label: 'Facts' },
  { key: 'deps', label: 'Deps' },
  { key: 'changelog', label: 'Changelog' },
];

export default function ScopeView({ domain = 'ops' }) {
  // Parse initial tab from URL path (e.g. /scope/deps -> 'deps')
  const pathTab = typeof window !== 'undefined' ? window.location.pathname.split('/').pop() : '';
  const validTabs = ['sources', 'facts', 'deps', 'changelog'];
  const initialTab = validTabs.includes(pathTab) ? pathTab : 'sources';
  const [tab, setTab] = useState(initialTab);
  const [changelog, setChangelog] = useState([]);
  const [clLoading, setClLoading] = useState(false);
  const accent = `var(--accent-${domain})`;
  const sources = SOURCES[domain] || [];
  const facts = FACTS[domain] || [];
  const deps = DEPS[domain] || [];

  useEffect(() => {
    if (tab === 'changelog' && changelog.length === 0) {
      setClLoading(true);
      fetch(`/api/scope/changelog?domain=${domain}`).then(r => r.ok ? r.json() : { commits: [] }).then(d => { setChangelog(Array.isArray(d?.commits) ? d.commits : []); setClLoading(false); }).catch(() => setClLoading(false));
    }
  }, [tab, domain]);

  return (
    <div style={{ padding: 'var(--gap-md)', maxWidth: 900 }}>
      <div style={{ display: 'flex', gap: 'var(--gap-xs)', marginBottom: 'var(--gap-md)', borderBottom: '1px solid var(--border)', paddingBottom: 'var(--gap-xs)' }}>
        {TABS.map(t => (
          <button key={t.key} onClick={() => setTab(t.key)} style={{
            padding: '6px 16px', fontSize: 'var(--font-size-sm)', fontWeight: 500,
            background: 'none', border: 'none', cursor: 'pointer',
            color: tab === t.key ? accent : 'var(--text-muted)',
            borderBottom: tab === t.key ? `2px solid ${accent}` : '2px solid transparent',
          }}>{t.label}</button>
        ))}
      </div>

      {tab === 'sources' && (
        <div>
          <h3 style={{ fontSize: 'var(--font-size-md)', marginBottom: 'var(--gap-sm)' }}>Datenquellen — {domain.toUpperCase()}</h3>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))', gap: 'var(--gap-sm)' }}>
            {sources.map((s, i) => {
              const Tag = s.url ? 'a' : 'div';
              return (
                <Tag key={i} href={s.url} target={s.url ? '_blank' : undefined} rel={s.url ? 'noopener noreferrer' : undefined} style={{
                  display: 'flex', alignItems: 'center', gap: 'var(--gap-sm)', padding: 'var(--gap-sm)',
                  borderRadius: 'var(--border-radius)', background: 'var(--bg-secondary)',
                  textDecoration: 'none', color: 'var(--text-primary)',
                  border: '1px solid var(--border)',
                }}>
                  <div style={{ width: 36, height: 36, borderRadius: 'var(--border-radius)', background: `${accent}20`, color: accent, display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: 14, flexShrink: 0 }}>{s.name[0]}</div>
                  <div style={{ flex: 1 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                      <span style={{ fontSize: 'var(--font-size-sm)', fontWeight: 500 }}>{s.name}</span>
                      <span className="badge badge-off" style={{ fontSize: 8 }}>{s.type}</span>
                    </div>
                    <div style={{ fontSize: 'var(--font-size-xs)', color: 'var(--text-muted)' }}>{s.desc}</div>
                  </div>
                </Tag>
              );
            })}
          </div>
        </div>
      )}

      {tab === 'facts' && (
        <div>
          <h3 style={{ fontSize: 'var(--font-size-md)', marginBottom: 'var(--gap-sm)' }}>Key Facts — {domain.toUpperCase()}</h3>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--gap-xs)' }}>
            {facts.map((f, i) => (
              <div key={i} style={{ display: 'flex', alignItems: 'baseline', gap: 'var(--gap-sm)', padding: 'var(--gap-sm)', background: 'var(--bg-secondary)', borderRadius: 'var(--border-radius)', border: '1px solid var(--border)' }}>
                <span style={{ fontWeight: 600, fontSize: 'var(--font-size-sm)', color: accent, minWidth: 100 }}>{f.key}</span>
                <span style={{ fontSize: 'var(--font-size-xs)', color: 'var(--text-secondary)' }}>{f.value}</span>
              </div>
            ))}
          </div>
        </div>
      )}

      {tab === 'deps' && (
        <div>
          <h3 style={{ fontSize: 'var(--font-size-md)', marginBottom: 'var(--gap-sm)' }}>Abhaengigkeiten — {domain.toUpperCase()}</h3>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--gap-xs)' }}>
            {deps.map((d, i) => (
              <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 'var(--gap-sm)', padding: 'var(--gap-sm)', background: 'var(--bg-secondary)', borderRadius: 'var(--border-radius)', border: '1px solid var(--border)' }}>
                <span style={{ width: 8, height: 8, borderRadius: '50%', background: d.status === 'ok' ? 'var(--color-ok, #9ece6a)' : 'var(--color-warn, #e0af68)', flexShrink: 0 }} />
                <span style={{ fontWeight: 600, fontSize: 'var(--font-size-sm)', minWidth: 130, color: accent }}>{d.service}</span>
                <span style={{ fontSize: 'var(--font-size-xs)', color: 'var(--text-muted)' }}>→</span>
                <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}>
                  {d.depends.map((dep, j) => <span key={j} className="badge badge-off" style={{ fontSize: 9 }}>{dep}</span>)}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {tab === 'changelog' && (
        <div>
          <h3 style={{ fontSize: 'var(--font-size-md)', marginBottom: 'var(--gap-sm)' }}>Changelog — {domain.toUpperCase()}</h3>
          {clLoading && <div style={{ color: 'var(--text-muted)' }}>Lade Git-History...</div>}
          <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            {changelog.map((c, i) => (
              <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 'var(--gap-sm)', padding: 'var(--gap-xs) var(--gap-sm)', background: 'var(--bg-secondary)', borderRadius: 'var(--border-radius)', border: '1px solid var(--border)' }}>
                <span style={{ fontFamily: 'var(--font-mono)', fontSize: 10, color: accent, minWidth: 60 }}>{c.hash}</span>
                <span style={{ fontSize: 'var(--font-size-xs)', flex: 1 }}>{c.message}</span>
                <span style={{ fontSize: 10, color: 'var(--text-muted)', fontFamily: 'var(--font-mono)', flexShrink: 0 }}>{c.date}</span>
              </div>
            ))}
            {!clLoading && changelog.length === 0 && <div style={{ color: 'var(--text-muted)', fontSize: 'var(--font-size-xs)', textAlign: 'center', padding: '1rem' }}>Keine Commits gefunden</div>}
          </div>
        </div>
      )}
    </div>
  );
}
